import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import Scene from './Scene';
import { fetchModelFile } from '../../../actions/ModelActions.redux';
import { saveUUIDs } from '../../../actions/ThreeActions.redux';

const mapStateToProps = (state) => ({
  activeModels: state.models.activeModels,
  mapId: state.config.map,
  places: state.places.places,
  modelData: state.places.modelData,
  newPlace: state.places.newPlace,
  uuids: state.three.uuids,
  modelBlobs: state.models.modelBlobs,
  lights: state.lights,
  settings: state.settings,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ fetchModelFile, saveUUIDs }, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Scene));
